import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { EDragDropObject } from "source/app/services/Shared/EDragDropObject";
import { useDropTarget } from "source/app/services/Shared/Hooks/useDropTarget";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "../../../../../services/UI/State/State";
import DreamHelpers from "../../DreamHelpers/DreamHelpers";
import { IDreamsState } from "../../IDreamsState";
import { Sounds } from "source/app/services/Sound/Sounds";
const localStyles = require("../DreamRow.css");

export function DreamDeleteDropTarget({ dream }: { dream: IDream }) {
    const dropTargetResult = useDropTarget<IDream>(
        [EDragDropObject.dreamRow],
        DeleteDreamAsync
    );

    if (
        !dropTargetResult.isDragging ||
        dropTargetResult.draggedObject.id !== dream.id
    ) {
        return null;
    }

    return (
        <span
            ref={dropTargetResult.dropTargetRef}
            className={`${localStyles.dropTarget} ${localStyles.dropTargetDelete}`}
            data-is-over={dropTargetResult.isOver}
        >
            <IconWithText
                iconSuffix={EGlyphicon.trash}
                whenClicked={() => {}}
                displayAsBlock={false}
            >
                Delete
            </IconWithText>
        </span>
    );
}

export async function DeleteDreamAsync(dream: IDream) {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);
    const allLinks = DreamHelpers.GetAllLinks(dream, dreams.state.sortedData);

    return WithAnimatedProgressBarAsync(async () => {
        Sounds.shoutWhoo.Play();
        await DreamHelpers.DeleteDream(dream, allLinks, false);
    });
}
